/* turnstile*/

  const TURNSTILE_SITE_KEY =

  "0x4AAAAAAETzE_bYUNL27F_Z";



const TURNSTILE_SCRIPT_URL =

  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";



function waitForTurnstile(

  timeoutMs = 10000

) {

  return new Promise(

    (resolve, reject) => {

      const startedAt =

        Date.now();



      const timer =

        window.setInterval(

          () => {

            if (

              window.turnstile

            ) {

              clearInterval(

                timer

              );



              resolve(

                window.turnstile

              );



              return;

            }



            if (

              Date.now() -

                startedAt >

              timeoutMs

            ) {

              clearInterval(

                timer

              );



              reject(

                new Error(

                  "TURNSTILE_LOAD_TIMEOUT"

                )

              );

            }

          },

          50

        );

    }

  );

}



function loadTurnstile() {

  if (window.turnstile) {

    return Promise.resolve(

      window.turnstile

    );

  }



  if (

    window

      .__BUTIKLE_TURNSTILE_LOAD_PROMISE

  ) {

    return window

      .__BUTIKLE_TURNSTILE_LOAD_PROMISE;

  }



  window

    .__BUTIKLE_TURNSTILE_LOAD_PROMISE =

    new Promise(

      (resolve, reject) => {

        const existingScript =

          document.querySelector(

            'script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]'

          );



        if (existingScript) {

          waitForTurnstile()

            .then(resolve)

            .catch(reject);



          return;

        }



        const script =

          document.createElement(

            "script"

          );



        script.src =

          TURNSTILE_SCRIPT_URL;



        script.async = true;

        script.defer = true;



        script.onload =

          async () => {

            try {

              const turnstile =

                await waitForTurnstile();



              resolve(

                turnstile

              );

            } catch (error) {

              reject(error);

            }

          };



        script.onerror =

          () => {

            reject(

              new Error(

                "TURNSTILE_LOAD_FAILED"

              )

            );

          };



        document.head.appendChild(

          script

        );

      }

    ).catch(

      (error) => {

        window

          .__BUTIKLE_TURNSTILE_LOAD_PROMISE =

          null;



        throw error;

      }

    );



  return window

    .__BUTIKLE_TURNSTILE_LOAD_PROMISE;

}



async function getTurnstileToken(

  action

) {

  const turnstile =

    await loadTurnstile();



  return new Promise(

    (resolve, reject) => {

      const container =

        document.createElement(

          "div"

        );



      container.id =

        `butikle-turnstile-${Date.now()}-${Math.random()

          .toString(36)

          .slice(2)}`;



      document.body.appendChild(

        container

      );



      let widgetId = null;

      let finished = false;



      const cleanup = () => {

        try {

          if (

            widgetId !== null

          ) {

            turnstile.remove(

              widgetId

            );

          }

        } catch {}



        container.remove();

      };



      const finish = (

        error,

        token = ""

      ) => {

        if (finished) {

          return;

        }



        finished = true;



        clearTimeout(

          timeoutTimer

        );



        cleanup();



        if (error) {

          reject(error);

          return;

        }



        resolve(token);

      };



      const timeoutTimer =

        setTimeout(

          () => {

            finish(

              new Error(

                "TURNSTILE_TIMEOUT"

              )

            );

          },

          20000

        );



      try {

        widgetId =

          turnstile.render(

            `#${container.id}`,

            {

              sitekey:

                TURNSTILE_SITE_KEY,



              action,



              execution:

                "execute",



              "response-field":

                false,



              callback:

                (token) => {

                  if (!token) {

                    finish(

                      new Error(

                        "TURNSTILE_EMPTY_TOKEN"

                      )

                    );



                    return;

                  }



                  finish(

                    null,

                    token

                  );

                },



              "error-callback":

                (code) => {

                  finish(

                    new Error(

                      `TURNSTILE_ERROR_${

                        code ||

                        "UNKNOWN"

                      }`

                    )

                  );



                  return true;

                },



              "expired-callback":

                () => {

                  finish(

                    new Error(

                      "TURNSTILE_EXPIRED"

                    )

                  );

                },



              "timeout-callback":

                () => {

                  finish(

                    new Error(

                      "TURNSTILE_TIMEOUT"

                    )

                  );

                },

            }

          );



        turnstile.execute(

          `#${container.id}`

        );

      } catch (error) {

        finish(error);

      }

    }

  );

}

  /*turnstile*/



(function () {

  "use strict";



  const FORM_ID =

    "60CLO6EbsnrYER4pkwxb";



  const FUNCTIONS_BASE_URL =

    "https://europe-west1-butikleapp.cloudfunctions.net";



  const root =

    document.getElementById(

      "akay-appointment-page"

    );



  if (

    !root ||

    root.dataset.initialized === "true"

  ) {

    return;

  }



  root.dataset.initialized =

    "true";



  const form =

    document.getElementById(

      "akay-appointment-form"

    );



  const loading =

    document.getElementById(

      "akay-form-loading"

    );



  const statusBox =

    document.getElementById(

      "akay-form-status"

    );



  const submitButton =

    document.getElementById(

      "akay-submit-button"

    );



  const branchSelect =

    document.getElementById(

      "akay-branch"

    );



  const boutiqueDropdown =

  document.getElementById(

    "akay-boutique-dropdown"

  );



const boutiqueTrigger =

  document.getElementById(

    "akay-boutique-trigger"

  );



const boutiqueTriggerContent =

  document.getElementById(

    "akay-boutique-trigger-content"

  );



const boutiqueMenu =

  document.getElementById(

    "akay-boutique-menu"

  );



  const nameInput =

    document.getElementById(

      "akay-name"

    );



  const emailInput =

    document.getElementById(

      "akay-email"

    );



  const telephoneInput =

    document.getElementById(

      "akay-telephone"

    );



  const selectedTimeInput =

    document.getElementById(

      "akay-selected-time"

    );



  const noteInput =

    document.getElementById(

      "akay-note"

    );



  const termsInput =

    document.getElementById(

      "akay-terms"

    );



  const termsLink =

    document.getElementById(

      "akay-terms-link"

    );



  const privacyLink =

    document.getElementById(

      "akay-privacy-link"

    );



 /*

 * Dil tespitinde öncelik:

 *

 * 1. URL yolu: /en/, /en-us/, /en-gb/

 * 2. Shopify'ın JavaScript locale bilgisi

 * 3. Liquid data attribute

 * 4. HTML lang

 */

const pathFirstSegment =

  window.location.pathname

    .split("/")

    .filter(Boolean)[0]

    ?.toLowerCase() || "";



const localeFromPath =

  /^[a-z]{2}(?:-[a-z]{2})?$/.test(

    pathFirstSegment

  )

    ? pathFirstSegment

    : "";



const shopLanguage =

  String(

    localeFromPath ||

    window.Shopify?.locale ||

    root.dataset.shopLanguage ||

    document.documentElement.lang ||

    "tr"

  )

    .trim()

    .toLowerCase();



const isEnglish =

  shopLanguage === "en" ||

  shopLanguage.startsWith("en-");



 const SHOPIFY_LOCALE_ROOT =

  window.Shopify?.routes?.root ||

  (isEnglish ? "/en/" : "/");



const SUCCESS_REDIRECT_URL =

  `${window.location.origin}${SHOPIFY_LOCALE_ROOT}pages/akay-randevu-talep-onay`;



  function tx(

    turkishText,

    englishText

  ) {

    return isEnglish

      ? englishText

      : turkishText;

  }



  const fieldErrors = {

    branch:

      document.getElementById(

        "akay-branch-error"

      ),



    name:

      document.getElementById(

        "akay-name-error"

      ),



    email:

      document.getElementById(

        "akay-email-error"

      ),



    telephone:

      document.getElementById(

        "akay-telephone-error"

      ),



    selectedTime:

      document.getElementById(

        "akay-selected-time-error"

      ),



    terms:

      document.getElementById(

        "akay-terms-error"

      ),

  };



  let formInfo = null;

  let branches = [];

  let submitting = false;

  let datePicker = null;

  let minimumDateTimer = null;



  function setText(

    id,

    value

  ) {

    const element =

      document.getElementById(id);



    if (element) {

      element.textContent =

        value;

    }

  }



  function setHTML(

    id,

    value

  ) {

    const element =

      document.getElementById(id);



    if (element) {

      element.innerHTML =

        value;

    }

  }



  function applyPageLanguage() {

    setHTML(

      "akay-intro-text",

      tx(

        "Randevularımız <strong>ücretsizdir.</strong>",

        "There is <strong>no service fee</strong> for wedding dress fittings during our appointments."

      )

    );



    setText(

      "akay-form-title",

      tx(

        "Randevu Talep Formu",

        "Appointment Request Form"

      )

    );



    setText(

      "akay-branch-label",

      tx(

        "Butik Seçiniz *",

        "Select a Boutique *"

      )

    );



    setText(

      "akay-name-label",

      tx(

        "Adınız *",

        "Your Name *"

      )

    );



    setText(

      "akay-email-label",

      tx(

        "Emailiniz *",

        "Your Email *"

      )

    );



    setText(

      "akay-telephone-label",

      tx(

        "Telefonunuz *",

        "Your Phone Number *"

      )

    );



    setText(

      "akay-selected-time-label",

      tx(

        "Randevu Talep Tarih ve Saati *",

        "Appointment Request Date and Time *"

      )

    );



    setText(

      "akay-note-label",

      tx(

        "Notunuz",

        "Your Note"

      )

    );



    setText(

      "akay-terms-link",

      tx(

        "Kullanım Koşulları",

        "Terms and Conditions"

      )

    );



    setText(

      "akay-terms-and",

      tx(

        " ve ",

        " and "

      )

    );



    setText(

      "akay-privacy-link",

      tx(

        "Gizlilik Politikası",

        "Privacy Policy"

      )

    );



    setText(

      "akay-terms-after",

      tx(

        " metinlerini okudum ve kabul ediyorum.",

        ". I have read and accept these terms."

      )

    );



    setText(

      "akay-bottom-description",

      tx(

        "Gönderilen bilgiler randevu talebi niteliğindedir. Randevunuz, danışmanlarımızın sizinle iletişime geçmesinden sonra onaylanır.",

        "The submitted information is an appointment request. Your appointment will be confirmed after our consultants contact you."

      )

    );



    setText(

      "akay-submit-button",

      tx(

        "Randevu Talebi Gönder",

        "Submit Appointment Request"

      )

    );



    nameInput.placeholder =

      tx(

        "Adınız",

        "Your Name"

      );



    emailInput.placeholder =

      tx(

        "Emailiniz",

        "Your Email"

      );



    telephoneInput.placeholder =

      tx(

        "Telefonunuz",

        "Your Phone Number"

      );



    selectedTimeInput.placeholder =

      tx(

        "Tarih ve saat seçiniz",

        "Select a date and time"

      );



    noteInput.placeholder =

      tx(

        "Notunuz",

        "Your Note"

      );



    setHTML(

      "akay-info-1",

      tx(

        "Randevu almak için butiklerimizi <strong>mesai saatleri içerisinde arayabilirsiniz</strong>.",

        "You may call our boutiques <strong>during business hours</strong> to request an appointment."

      )

    );



    setHTML(

      "akay-info-2",

      tx(

        "Butiklerimizin çalışma saatlerini <a href=\"https://akay.com.tr/pages/butiklerimiz\" target=\"_blank\" rel=\"noopener noreferrer\">butiklerimiz</a> kısmında inceleyebilirsiniz.",

        "You can view our boutiques' opening hours on the <a href=\"https://akay.com.tr/en/pages/butiklerimiz\" target=\"_blank\" rel=\"noopener noreferrer\">boutiques</a> page."

      )

    );



    setHTML(

      "akay-info-3",

      tx(

        "Butiğimiz sizinle iletişim kurana kadar randevu bilgileriniz yalnızca talep olarak kalacak olup, <strong>iletişim kurulduktan sonra randevu kaydınız oluşturulacaktır.</strong>",

        "Your appointment details remain a request until our boutique contacts you. <strong>Your appointment record will be created after contact.</strong>"

      )

    );



    setHTML(

      "akay-info-4",

      tx(

        "Randevu talebiniz danışmanlarımızın sizinle <strong>iletişime geçmesi sonrasında onaylanmaktadır.</strong>",

        "Your appointment request is <strong>confirmed after our consultants contact you.</strong>"

      )

    );



    setHTML(

      "akay-info-5",

      tx(

        "Randevulara <strong>maksimum 4 kişi</strong> kabul edilmektedir.",

        "A maximum of <strong>4 guests</strong> are accepted for appointments."

      )

    );



    setHTML(

      "akay-info-6",

      tx(

        "Randevu süremiz tüm butiklerimiz için <strong>1 saattir</strong>. Randevu onayınız ile beraber size ayrılan randevu saatinde butiğimizde olmanız önem arz etmektedir.",

        "Appointments last <strong>1 hour</strong> at all our boutiques. Please arrive at the confirmed appointment time reserved for you."

      )

    );



    setHTML(

      "akay-info-7",

      tx(

        "Butiklerimizde <strong>otopark veya vale hizmeti bulunmamaktadır</strong>.",

        "Our boutiques <strong>do not provide parking or valet service</strong>."

      )

    );



    setText(

      "akay-seo-title",

      tx(

        "Gelinlik Randevu",

        "Wedding Dress Appointment"

      )

    );



    setText(

      "akay-seo-p1",

      tx(

        "AKAY Gelinlik butiklerinde gelinlik modellerini yakından incelemek ve farklı tasarımları deneyebilmek için randevu oluşturabilirsiniz. Randevu sırasında gelin adayları prenses gelinlik, balık gelinlik ve A kesim gelinlik modelleri arasından kendilerine en uygun tasarımları deneyebilir. Uzman stil danışmanlarımız gelinlik seçimi sürecinde gelin adaylarına yardımcı olarak düğün konseptine ve vücut tipine en uygun gelinlik modelini belirlemelerine destek olur.",

        "You can request an appointment at AKAY boutiques to view wedding dress models closely and try different designs. During the appointment, brides can try princess, mermaid and A-line wedding dresses. Our expert style consultants help brides choose the design that best suits their wedding concept and body type."

      )

    );



    setText(

      "akay-seo-p2",

      tx(

        "AKAY Gelinlik randevu sistemi sayesinde gelin adayları butiklerde daha konforlu bir deneyim yaşayabilir ve gelinlik modellerini detaylı şekilde inceleyebilirler. Randevu oluşturduktan sonra danışmanlarımız sizinle iletişime geçerek randevu saatini onaylar ve gelinlik deneme sürecine dair gerekli bilgileri paylaşır.",

        "With the AKAY appointment system, brides can enjoy a more comfortable boutique experience and examine wedding dress models in detail. After you submit a request, our consultants contact you to confirm the appointment time and share the necessary information about the fitting process."

      )

    );



    const warning =

      document.getElementById(

        "akay-info-english-phone-warning"

      );



    if (warning) {

      warning.hidden =

        !isEnglish;



      warning.innerHTML =

        isEnglish

          ? "Please note that a <strong>valid Turkish phone number</strong> is required when submitting the form. If you do not speak Turkish, please attend your appointment with someone who can assist you in Turkish."

          : "";

    }

  }



  function setLoading(

    isLoading,

    message

  ) {

    if (message) {

      loading.textContent =

        message;

    }



    loading.classList.toggle(

      "is-visible",

      Boolean(isLoading)

    );

  }



  function showStatus(

    message

  ) {

    statusBox.textContent =

      message || "";



    statusBox.classList.toggle(

      "is-visible",

      Boolean(message)

    );

  }



  function clearFieldError(

    fieldName

  ) {

    const error =

      fieldErrors[fieldName];



    if (!error) {

      return;

    }



    error.textContent =

      "";



    error.classList.remove(

      "is-visible"

    );



    const wrapper =

      error.closest(

        ".akay-field, .akay-terms-wrapper"

      );



    if (wrapper) {

      wrapper.classList.remove(

        "has-error"

      );

    }

  }



  function setFieldError(

    fieldName,

    message

  ) {

    const error =

      fieldErrors[fieldName];



    if (!error) {

      return;

    }



    error.textContent =

      `ⓘ ${message}`;



    error.classList.add(

      "is-visible"

    );



    const wrapper =

      error.closest(

        ".akay-field, .akay-terms-wrapper"

      );



    if (wrapper) {

      wrapper.classList.add(

        "has-error"

      );

    }

  }



  function clearAllFieldErrors() {

    Object.keys(

      fieldErrors

    ).forEach(

      clearFieldError

    );

  }



  function callableError(

    payload,

    fallback

  ) {

    return (

      payload?.error?.message ||

      payload?.error?.details ||

      fallback

    );

  }



  async function callCallable(

    functionName,

    data

  ) {

    const response =

      await fetch(

        `${FUNCTIONS_BASE_URL}/${functionName}`,

        {

          method:

            "POST",



          mode:

            "cors",



          credentials:

            "omit",



          headers: {

            "Content-Type":

              "application/json",

          },



          body:

            JSON.stringify({

              data,

            }),

        }

      );



    let payload;



    try {

      payload =

        await response.json();

    } catch (error) {

      throw new Error(

        tx(

          "Sunucudan geçerli bir yanıt alınamadı.",

          "A valid response could not be received from the server."

        )

      );

    }



    if (

      !response.ok ||

      payload?.error

    ) {

      throw new Error(

        callableError(

          payload,

          tx(

            "İşlem sırasında bir hata oluştu. Lütfen tekrar deneyiniz.",

            "An error occurred. Please try again."

          )

        )

      );

    }



    return (

      payload?.result ??

      payload?.data ??

      null

    );

  }



function normalizeTelephone(value) {

  const raw =

    String(value || "").trim();



  const hasPlus =

    raw.startsWith("+");



  /*

   * En uzun kabul edilen örnek:

   * +0902123256532

   *

   * Artı hariç 13 rakam.

   */

  const digits =

    raw

      .replace(/\D/g, "")

      .slice(0, 13);



  return hasPlus

    ? `+${digits}`

    : digits;

}

function isTelephoneValid(value) {

  const digits =

    normalizeTelephone(value)

      .replace(/\D/g, "");



  /*

   * Kabul edilen biçimler:

   *

   * +905034651295

   * 5304651092

   * 05304651092

   * 01213256532

   * 2123256532

   * +0902123256532

   *

   * Kabul edilen önekler:

   * - Öneksiz

   * - 0

   * - 90

   * - 090

   */

  return /^(?:090|90|0)?[1-5]\d{9}$/.test(

    digits

  );

}



  function toNativeDateTimeValue(

    date

  ) {

    const pad =

      function (value) {

        return String(

          value

        ).padStart(

          2,

          "0"

        );

      };



    return [

      date.getFullYear(),

      "-",

      pad(

        date.getMonth() + 1

      ),

      "-",

      pad(

        date.getDate()

      ),

      "T",

      pad(

        date.getHours()

      ),

      ":",

      pad(

        date.getMinutes()

      ),

    ].join("");

  }



  function updateNativeMinimumDate() {

    if (

      selectedTimeInput.type ===

      "datetime-local"

    ) {

      selectedTimeInput.min =

        toNativeDateTimeValue(

          new Date()

        );

    }

  }



  function selectedAppointmentDate() {

    if (

      datePicker

        ?.selectedDates

        ?.[0]

    ) {

      return datePicker

        .selectedDates[0];

    }



    if (

      !selectedTimeInput.value

    ) {

      return null;

    }



    const date =

      new Date(

        selectedTimeInput.value

      );



    return Number.isNaN(

      date.getTime()

    )

      ? null

      : date;

  }



  function getNextAvailableAppointmentSlot(

  currentDate = new Date()

) {

  const now =

    new Date(currentDate);



  const openingTime =

    new Date(now);



  openingTime.setHours(

    10,

    0,

    0,

    0

  );



  const closingTime =

    new Date(now);



  closingTime.setHours(

    17,

    30,

    0,

    0

  );



  /*

   * Mağaza açılmadan önceyse

   * bugün 10:00.

   */

  if (

    now.getTime() <

    openingTime.getTime()

  ) {

    return openingTime;

  }



  /*

   * Bir sonraki yarım saate yuvarla.

   *

   * 13:01 → 13:30

   * 13:30 → 14:00

   * 13:45 → 14:00

   */

  const nextSlot =

    new Date(now);



  nextSlot.setSeconds(

    0,

    0

  );



  if (

    nextSlot.getMinutes() <

    30

  ) {

    nextSlot.setMinutes(

      30

    );

  } else {

    nextSlot.setHours(

      nextSlot.getHours() + 1,

      0,

      0,

      0

    );

  }



  /*

   * Bugün 17:30 hâlâ uygunsa

   * onu kullan.

   */

  if (

    nextSlot.getTime() <=

    closingTime.getTime()

  ) {

    return nextSlot;

  }



  /*

   * Bugün uygun saat kalmadıysa

   * yarın 10:00.

   */

  const tomorrow =

    new Date(now);



  tomorrow.setDate(

    tomorrow.getDate() + 1

  );



  tomorrow.setHours(

    10,

    0,

    0,

    0

  );



  return tomorrow;

}



function isSameCalendarDay(

  firstDate,

  secondDate

) {

  return (

    firstDate.getFullYear() ===

      secondDate.getFullYear() &&

    firstDate.getMonth() ===

      secondDate.getMonth() &&

    firstDate.getDate() ===

      secondDate.getDate()

  );

}



function dateToTimeString(

  date

) {

  const pad =

    function (value) {

      return String(value)

        .padStart(2, "0");

    };



  return `${pad(

    date.getHours()

  )}:${pad(

    date.getMinutes()

  )}`;

}



  function initializeDatePicker() {

  if (

    typeof window.flatpickr ===

    "function"

  ) {

    const initialSlot =

      getNextAvailableAppointmentSlot();



    datePicker =

      window.flatpickr(

        selectedTimeInput,

        {

          locale:

            !isEnglish &&

            window.flatpickr

              .l10ns

              ?.tr

              ? window.flatpickr

                  .l10ns

                  .tr

              : "default",



          enableTime: true,

          time_24hr: true,



          /*

           * Sadece :00 ve :30.

           */

          minuteIncrement: 30,



          minTime:

            dateToTimeString(

              initialSlot

            ),



          maxTime:

            "17:30",



          defaultHour:

            initialSlot.getHours(),



          defaultMinute:

            initialSlot.getMinutes(),



          dateFormat:

            "d/m/Y H:i",





          minDate:

            initialSlot,



          disableMobile: true,

          allowInput: false,

          clickOpens: true,



          onOpen: function (

            selectedDates,

            dateStr,

            instance

          ) {

            const nextSlot =

              getNextAvailableAppointmentSlot();



            instance.set(

              "minDate",

              nextSlot

            );



            /*

             * Varsayılan saat her açılışta

             * güncellensin.

             */

            instance.config.defaultHour =

              nextSlot.getHours();



            instance.config.defaultMinute =

              nextSlot.getMinutes();



            const selectedDate =

              selectedDates?.[0];



            /*

             * En erken seçilebilen gündeyse,

             * geçmiş saatleri gösterme.

             *

             * Daha sonraki bir gün seçilmişse

             * saatler 10:00'dan başlasın.

             */

            instance.set(

              "minTime",

              !selectedDate ||

              isSameCalendarDay(

                selectedDate,

                nextSlot

              )

                ? dateToTimeString(

                    nextSlot

                  )

                : "10:00"

            );



            instance.set(

              "maxTime",

              "17:30"

            );

          },



          onChange: function (

            selectedDates,

            dateStr,

            instance

          ) {

            const selectedDate =

              selectedDates?.[0];



            const nextSlot =

              getNextAvailableAppointmentSlot();



            instance.set(

              "minTime",

              selectedDate &&

              isSameCalendarDay(

                selectedDate,

                nextSlot

              )

                ? dateToTimeString(

                    nextSlot

                  )

                : "10:00"

            );



            instance.set(

              "maxTime",

              "17:30"

            );



            clearFieldError(

              "selectedTime"

            );



            showStatus("");

          },

        }

      );



    minimumDateTimer =

      window.setInterval(

        function () {

          if (!datePicker) {

            return;

          }



          const nextSlot =

            getNextAvailableAppointmentSlot();



          datePicker.set(

            "minDate",

            nextSlot

          );



          datePicker.config.defaultHour =

            nextSlot.getHours();



          datePicker.config.defaultMinute =

            nextSlot.getMinutes();

        },

        60000

      );



    return;

  }



  // Mevcut native fallback kodun burada devam eder.

    /*

     * Flatpickr yüklenmezse

     * tarayıcının kendi tarih-saat

     * seçicisine geçilir.

     */

    selectedTimeInput.readOnly =

      false;



    selectedTimeInput.type =

      "datetime-local";



    selectedTimeInput.step =

      "300";



    updateNativeMinimumDate();



    selectedTimeInput.addEventListener(

      "change",

      function () {

        clearFieldError(

          "selectedTime"

        );



        showStatus("");

      }

    );



    minimumDateTimer =

      window.setInterval(

        updateNativeMinimumDate,

        60000

      );

  }



  function createMetricEventId() {

    return (

      window.crypto

        ?.randomUUID

        ?.() ||

      `${Date.now()}_${Math.random()

        .toString(36)

        .slice(2)}`

    );

  }



  const pageMetricId =

    createMetricEventId();



  function recordMetric(

    metricType

  ) {

    callCallable(

      "recordAppointmentRequestFormMetric",

      {

        relatedFormId:

          FORM_ID,



        metricType,



        metricEventId:

          pageMetricId,



        sentParentDomain:

          window.location.hostname

            .toLowerCase(),



        forCustomPage:

          true,

      }

    ).catch(

      function () {

        /*

         * Metric hatası formu

         * engellemez.

         */

      }

    );

  }





  function getBranchInitials(publicName) {

  return String(publicName || "")

    .trim()

    .split(/\s+/)

    .slice(0, 2)

    .map(function (word) {

      return word.charAt(0).toUpperCase();

    })

    .join("");

}



function createBranchImage(branch) {

  if (branch.imageUrl) {

    const image =

      document.createElement("img");



    image.className =

      "akay-boutique-image";



    image.src =

      branch.imageUrl;



    image.alt =

      branch.publicName;



    image.loading =

      "lazy";



    image.addEventListener(

      "error",

      function () {

        const placeholder =

          createBranchImagePlaceholder(

            branch

          );



        image.replaceWith(

          placeholder

        );

      },

      { once: true }

    );



    return image;

  }



  return createBranchImagePlaceholder(

    branch

  );

}



function createBranchImagePlaceholder(branch) {

  const placeholder =

    document.createElement("span");



  placeholder.className =

    "akay-boutique-image-placeholder";



  placeholder.textContent =

    getBranchInitials(

      branch.publicName

    ) || "AK";



  return placeholder;

}



  function createBranchText(branch) {

  const wrapper =

    document.createElement("span");



  wrapper.className =

    "akay-boutique-text";



  const name =

    document.createElement("span");



  name.className =

    "akay-boutique-name";



  name.textContent =

    branch.publicName || "";



  wrapper.appendChild(name);



  const branchAddress =

    String(

      branch.address || ""

    ).trim();



  if (branchAddress) {

    const address =

      document.createElement("span");



    address.className =

      "akay-boutique-address";



    address.textContent =

      branchAddress;



    wrapper.appendChild(address);

  }



  return wrapper;

}



function setBoutiqueTrigger(branch) {

  boutiqueTriggerContent.replaceChildren();



  if (!branch) {

    boutiqueTriggerContent.textContent =

      tx(

        "Butik seçiniz",

        "Select a boutique"

      );



    return;

  }



  const image =

    createBranchImage(branch);



 const branchText =

  createBranchText(branch);



boutiqueTriggerContent.append(

  image,

  branchText

);

}



function closeBoutiqueMenu() {

  boutiqueMenu.hidden =

    true;



  boutiqueTrigger.setAttribute(

    "aria-expanded",

    "false"

  );

}



function openBoutiqueMenu() {

  if (boutiqueTrigger.disabled) {

    return;

  }



  boutiqueMenu.hidden =

    false;



  boutiqueTrigger.setAttribute(

    "aria-expanded",

    "true"

  );

}



function selectBoutique(branch) {

  branchSelect.value =

    branch.id;



  setBoutiqueTrigger(

    branch

  );



  boutiqueMenu

    .querySelectorAll(

      ".akay-boutique-option"

    )

    .forEach(function (option) {

      option.classList.toggle(

        "is-selected",

        option.dataset.branchId ===

          branch.id

      );

    });



  closeBoutiqueMenu();



  branchSelect.dispatchEvent(

    new Event(

      "change",

      {

        bubbles: true,

      }

    )

  );

}



  function populateBranches(

  receivedBranches

) {

 branches =

  Array.isArray(receivedBranches)

    ? receivedBranches

        .filter(function (branch) {

          return (

            branch?.id &&

            branch?.publicName

          );

        })

        .sort(function (a, b) {

          const an =

            Number.isFinite(

              Number(a.sortNumber)

            )

              ? Number(a.sortNumber)

              : Number.POSITIVE_INFINITY;



          const bn =

            Number.isFinite(

              Number(b.sortNumber)

            )

              ? Number(b.sortNumber)

              : Number.POSITIVE_INFINITY;



          if (an !== bn) {

            return an - bn;

          }



          return String(

            a.publicName || ""

          ).localeCompare(

            String(

              b.publicName || ""

            )

          );

        })

    : [];



  branchSelect.value =

    "";



  boutiqueMenu.replaceChildren();



  setBoutiqueTrigger(null);



  branches.forEach(

    function (branch) {

      const option =

        document.createElement(

          "button"

        );



      option.type =

        "button";



      option.className =

        "akay-boutique-option";



      option.dataset.branchId =

        branch.id;



      option.setAttribute(

        "role",

        "option"

      );



      const image =

        createBranchImage(branch);



      const branchText =

  createBranchText(branch);



option.append(

  image,

  branchText

);



option.setAttribute(

  "aria-label",

  [

    branch.publicName,

    branch.address,

  ]

    .filter(Boolean)

    .join(" - ")

);



      option.addEventListener(

        "click",

        function () {

          selectBoutique(

            branch

          );

        }

      );



      boutiqueMenu.appendChild(

        option

      );

    }

  );



  boutiqueTrigger.disabled =

    branches.length === 0;



  submitButton.disabled =

    branches.length === 0;



  closeBoutiqueMenu();

}



  function applyFormInfo(

    receivedFormInfo

  ) {

    formInfo =

      receivedFormInfo || {};



    populateBranches(

      formInfo.branches

    );



    if (

      formInfo.formbgcolor

    ) {

      root.style.setProperty(

        "--form-bg",

        formInfo.formbgcolor

      );

    }



    if (

      formInfo.formtextcolor

    ) {

      root.style.setProperty(

        "--form-text",

        formInfo.formtextcolor

      );

    }



    if (

      formInfo.formbuttonbgcolor

    ) {

      root.style.setProperty(

        "--button-bg",

        formInfo.formbuttonbgcolor

      );

    }



    if (

      formInfo.formbuttontextcolor

    ) {

      root.style.setProperty(

        "--button-text",

        formInfo.formbuttontextcolor

      );

    }



    if (

      formInfo.formfont

    ) {

      root.style.setProperty(

        "--font",

        formInfo.formfont

      );

    }



    termsLink.href =

      formInfo

        .formcustomuseragreementurl ||

      "/policies/terms-of-service";



    privacyLink.href =

      formInfo

        .formcustomprivacypolicyurl ||

      "/policies/privacy-policy";



     submitButton.disabled =

    branches.length === 0;

  }



  function resetAppointmentFormState() {

  submitting = false;



  form.reset();



  /*

   * Varsayılan olarak sözleşme

   * yeniden seçili gelsin.

   */

  termsInput.checked = true;



  /*

   * Şube seçimini temizle.

   */

  branchSelect.value = "";



  setBoutiqueTrigger(null);



  boutiqueMenu

    .querySelectorAll(

      ".akay-boutique-option"

    )

    .forEach(function (option) {

      option.classList.remove(

        "is-selected"

      );

    });



  closeBoutiqueMenu();



  /*

   * Takvim seçimini temizle.

   */

  if (datePicker) {

    datePicker.clear();

    datePicker.close();

  }



  selectedTimeInput.value = "";



  /*

   * Hata ve loading durumlarını temizle.

   */

  clearAllFieldErrors();

  showStatus("");

  setLoading(false);



  /*

   * Form bilgileri yüklenmişse

   * butonları tekrar kullanılabilir yap.

   */

  const hasBranches =

    branches.length > 0;



  boutiqueTrigger.disabled =

    !hasBranches;



  submitButton.disabled =

    !hasBranches;

}



  function validateForm() {

    clearAllFieldErrors();



    const branchId =

      branchSelect.value.trim();



    const name =

      nameInput.value.trim();



    const email =

      emailInput.value

        .trim()

        .toLowerCase();



    const telephone =

      normalizeTelephone(

        telephoneInput.value

      );



    const selectedTime =

      selectedAppointmentDate();



    let hasError =

      false;



    if (

      !branchId ||

      !branches.some(

        function (branch) {

          return (

            branch.id ===

            branchId

          );

        }

      )

    ) {

      setFieldError(

        "branch",

        tx(

          "Lütfen butik seçiniz.",

          "Please select a boutique."

        )

      );



      hasError =

        true;

    }



    if (!name) {

      setFieldError(

        "name",

        tx(

          "Lütfen adınızı giriniz.",

          "Please enter your name."

        )

      );



      hasError =

        true;

    }



    if (

      !email ||

      !emailInput

        .validity

        .valid

    ) {

      setFieldError(

        "email",

        tx(

          "Lütfen geçerli bir email adresi giriniz.",

          "Please enter a valid email address."

        )

      );



      hasError =

        true;

    }



   if (

  !isTelephoneValid(

    telephone

  )

) {

  setFieldError(

    "telephone",

    tx(

      "Telefon numarası hatalıdır. Lütfen geçerli bir Türkiye hattı giriniz.",

      "The phone number is invalid. Please enter a valid Turkish phone number."

    )

  );



  hasError =

    true;

}



    if (!selectedTime) {

      setFieldError(

        "selectedTime",

        tx(

          "Lütfen randevu tarihini ve saatini seçiniz.",

          "Please select an appointment date and time."

        )

      );



      hasError =

        true;

    } else if (

      selectedTime.getTime() <=

      Date.now()

    ) {

      setFieldError(

        "selectedTime",

        tx(

          "Randevu tarihi geçmiş bir tarih olamaz.",

          "The appointment date cannot be in the past."

        )

      );



      hasError =

        true;

    }



    if (

      !termsInput.checked

    ) {

      setFieldError(

        "terms",

        tx(

          "Devam etmek için kullanım koşullarını ve gizlilik politikasını kabul ediniz.",

          "Please accept the terms and privacy policy to continue."

        )

      );



      hasError =

        true;

    }



    if (hasError) {

      showStatus(

        tx(

          "Lütfen kırmızı işaretli alanları kontrol ediniz.",

          "Please check the fields marked in red."

        )

      );



      const firstInvalid =

        root.querySelector(

          ".akay-field.has-error input, " +

          ".akay-field.has-error select, " +

          ".akay-terms-wrapper.has-error input"

        );



      if (firstInvalid) {

        firstInvalid.focus();

      }



      return null;

    }



    return {

      fieldofrelatedformid:

        FORM_ID,



      fieldofselectedtime:

        selectedTime.toISOString(),



      fieldofemail:

        email,



      fieldoftel:

        telephone,



      fieldofnot:

        noteInput.value.trim(),



      fieldofbranchid:

        branchId,



      fieldofname:

        name,

    };

  }



  async function loadFormInfo() {

    recordMetric(

      "PageOpened"

    );



    setLoading(

      true,

      tx(

        "Randevu formu yükleniyor, lütfen bekleyiniz...",

        "The appointment form is loading. Please wait..."

      )

    );



    showStatus("");



    try {

      const receivedFormInfo =

        await callCallable(

          "fetchAppointmentRequestFormInfo",

          {

            relatedappointmentrequestformid:

              FORM_ID,



            sentParentDomain:

              window.location.hostname

                .toLowerCase(),



            forCustomPage:

              true,

          }

        );



      if (

        !receivedFormInfo

      ) {

        throw new Error(

          tx(

            "Form bilgileri alınamadı.",

            "The form information could not be received."

          )

        );

      }



      applyFormInfo(

        receivedFormInfo

      );



      recordMetric(

        "SuccessfullyLoaded"

      );

    } catch (error) {

      submitButton.disabled =

        true;



     boutiqueTrigger.disabled = true;



      showStatus(

        error?.message ||

        tx(

          "Randevu formu yüklenemedi. Lütfen sayfayı yenileyiniz.",

          "The appointment form could not be loaded. Please refresh the page."

        )

      );

    } finally {

      setLoading(false);

    }

  }



  async function handleSubmit(

    event

  ) {

    event.preventDefault();



    if (submitting) {

      return;

    }



    showStatus("");



    const formData =

      validateForm();



    if (!formData) {

      return;

    }



    submitting =

      true;



    submitButton.disabled =

      true;



    setLoading(

      true,

      tx(

        "Randevu talebiniz gönderiliyor...",

        "Your appointment request is being submitted..."

      )

    );



    try {



      const turnstileToken = await getTurnstileToken(

          "appointment_submit"

        );



      const result =

        await callCallable(

          "submitAppointmentRequestForm",

          {

            forminfodata:

              formData,



            sentParentDomain:

              window.location.hostname

                .toLowerCase(),



            forCustomPage:

              true,



            turnstileToken,

          }

        );



      if (

        !result

          ?.prerequestsuccessfullycreated

      ) {

        throw new Error(

          tx(

            "Randevu talebi oluşturulamadı.",

            "The appointment request could not be created."

          )

        );

      }



      resetAppointmentFormState();



      window.location.assign(

        SUCCESS_REDIRECT_URL

      );

    } catch (error) {

      showStatus(

        error?.message ||

        tx(

          "Randevu talebi gönderilemedi. Lütfen tekrar deneyiniz.",

          "The appointment request could not be submitted. Please try again."

        )

      );



      submitButton.disabled =

        false;

    } finally {

      submitting =

        false;



      setLoading(false);

    }

  }



  branchSelect.addEventListener(

    "change",

    function () {

      clearFieldError(

        "branch"

      );



      showStatus("");

    }

  );



  nameInput.addEventListener(

    "input",

    function () {

      clearFieldError(

        "name"

      );



      showStatus("");

    }

  );



  emailInput.addEventListener(

    "input",

    function () {

      clearFieldError(

        "email"

      );



      showStatus("");

    }

  );



  telephoneInput.addEventListener(

    "beforeinput",

    function (event) {

      if (

        event.inputType

          ?.startsWith(

            "delete"

          )

      ) {

        return;

      }



      const inserted =

        String(

          event.data || ""

        );



      const isDigits =

        /^\d+$/.test(

          inserted

        );



      const isLeadingPlus =

        inserted === "+" &&

        telephoneInput.selectionStart === 0 &&

        !telephoneInput.value.includes("+");



      if (

        inserted &&

        !isDigits &&

        !isLeadingPlus

      ) {

        event.preventDefault();

      }

    }

  );



  telephoneInput.addEventListener(

    "input",

    function () {

      telephoneInput.value =

        normalizeTelephone(

          telephoneInput.value

        );



      clearFieldError(

        "telephone"

      );



      showStatus("");

    }

  );



  telephoneInput.addEventListener(

  "blur",

  function () {

    const telephone =

      normalizeTelephone(

        telephoneInput.value

      );



    if (!telephone) {

      return;

    }



    if (

      !isTelephoneValid(

        telephone

      )

    ) {

      setFieldError(

        "telephone",

        tx(

          "Telefon numarası hatalıdır. Lütfen geçerli bir Türkiye hattı giriniz.",

          "The phone number is invalid. Please enter a valid Turkish phone number."

        )

      );



      return;

    }



    clearFieldError(

      "telephone"

    );

  }

);



  termsInput.addEventListener(

    "change",

    function () {

      clearFieldError(

        "terms"

      );



      showStatus("");

    }

  );



  window.addEventListener(

    "beforeunload",

    function () {

      if (

        minimumDateTimer

      ) {

        window.clearInterval(

          minimumDateTimer

        );

      }

    }

  );



  window.addEventListener(

  "pageshow",

  function (event) {

    const navigationEntry =

      window.performance

        ?.getEntriesByType

        ?.("navigation")

        ?.[0];



    const returnedWithBackButton =

      event.persisted ||

      navigationEntry?.type ===

        "back_forward";



    if (

      returnedWithBackButton

    ) {

      resetAppointmentFormState();

    }

  }

);



  boutiqueTrigger.addEventListener(

  "click",

  function () {

    if (boutiqueMenu.hidden) {

      openBoutiqueMenu();

    } else {

      closeBoutiqueMenu();

    }

  }

);



document.addEventListener(

  "click",

  function (event) {

    if (

      !boutiqueDropdown.contains(

        event.target

      )

    ) {

      closeBoutiqueMenu();

    }

  }

);



document.addEventListener(

  "keydown",

  function (event) {

    if (event.key === "Escape") {

      closeBoutiqueMenu();



      boutiqueTrigger.focus();

    }

  }

);





  applyPageLanguage();

  initializeDatePicker();



  form.addEventListener(

    "submit",

    handleSubmit

  );



  loadFormInfo();

})();
